import { render, staticRenderFns } from "./offlinePayment.vue?vue&type=template&id=67e3dc2c&scoped=true&"
import script from "./offlinePayment.vue?vue&type=script&lang=js&"
export * from "./offlinePayment.vue?vue&type=script&lang=js&"
import style0 from "./offlinePayment.vue?vue&type=style&index=0&id=67e3dc2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3dc2c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
